export default __webpack_public_path__ + "static/media/ambientTreesSquare.a230066d.jpg";